import React from "react";
import moment from "moment";
import { filter, isEmpty, isNil, join, map } from "lodash";
import { ColumnType } from "antd/lib/table";
import { SortOrder } from "antd/lib/table/interface";
import { DATETIME_FORMAT, EMPTY } from "constants/common";
import { AiccSubUser } from "types/model/aiccCustomer";
import PreviewDot from "./PreviewDot";
import styles from "./SubUserList.module.scss";

const formatDatetime = (datetime?: string) => (datetime ? moment(datetime).format(DATETIME_FORMAT) : EMPTY);

const getColumns = (sortKey: string, sortOrder: SortOrder): ColumnType<AiccSubUser>[] => [
  {
    title: "Subuser",
    dataIndex: "name",
    key: "name",
    width: 240,
    ellipsis: true,
    render: (_, { name, id, isPreview }) => (
      <div className={styles.subuser}>
        {isPreview && <PreviewDot />}
        <div className={styles.subuserName}>{`${name} (${id})`}</div>
      </div>
    ),
  },
  {
    title: "Customer Email",
    dataIndex: "customerEmail",
    key: "customerEmail",
    width: 240,
    ellipsis: true,
    render: (_, { customerEmail }) => customerEmail || EMPTY,
  },
  {
    title: "Language",
    dataIndex: "studyLanguages",
    key: "studyLanguages",
    width: 240,
    ellipsis: true,
    render: (_, { studyLanguages }) => (isEmpty(studyLanguages) ? EMPTY : join(map(studyLanguages, "name"), ", ")),
  },
  {
    title: "Fluency Level",
    dataIndex: "studyLanguages",
    key: "fluencyLevel",
    width: 240,
    ellipsis: true,
    render: (_, { studyLanguages }) => {
      const leveledLanguages = filter(studyLanguages, ({ fluencyLevel }) => !isNil(fluencyLevel));

      return isEmpty(leveledLanguages)
        ? EMPTY
        : join(
            map(leveledLanguages, ({ name, fluencyLevel }) => `${name} - ${fluencyLevel}`),
            ", "
          );
    },
  },
  {
    title: "Last Active At",
    dataIndex: "lastActiveAt",
    key: "last_active_at",
    width: 200,
    ellipsis: true,
    sorter: true,
    sortOrder: sortKey === "last_active_at" ? sortOrder : null,
    sortDirections: ["descend", "ascend", "descend"],
    render: (_, { lastActiveAt }) => formatDatetime(lastActiveAt),
  },
  {
    title: "First Used At",
    dataIndex: "firstUsedAt",
    key: "first_used_at",
    width: 200,
    ellipsis: true,
    sorter: true,
    sortOrder: sortKey === "first_used_at" ? sortOrder : null,
    sortDirections: ["descend", "ascend", "descend"],
    render: (_, { firstUsedAt }) => formatDatetime(firstUsedAt),
  },
];

export default getColumns;
